<template>
    <section ref="section1" class="mx-auto flex h-full flex-col">
        <v-register-head
            :step="1"
            :landing-route="registrationProcessData.routes.landing"
        ></v-register-head>
        <main
            class="flex h-full flex-col items-center justify-between overflow-y-scroll px-4 py-8 md:px-12"
        >
            <form
                method="POST"
                :action="
                    registrationProcessData.routes.getVerificationCodeRoute
                "
                id="get-verification-code-form"
            >
                <v-csrf-token></v-csrf-token>
                <div
                    class="flex h-full flex-col items-center justify-between px-4 py-8 md:px-12"
                >
                    <figure class="flex max-w-lg flex-col gap-11 lg:w-full">
                        <figure class="flex gap-3">
                            <div>
                                <v-icon icon="phone" size="8"></v-icon>
                            </div>
                            <div class="flex flex-col justify-center">
                                <div class="mb-3 text-heading-3-desktop">
                                    Vpišite svojo telefonsko številko
                                </div>
                                <div class="text-body-regular text-black-40">
                                    Na vašo telefonsko številko vam bomo poslali
                                    6-mestno verifikacijsko kodo
                                </div>
                            </div>
                        </figure>
                        <figure class="flex gap-3">
                            <div class="w-1/3">
                                <v-select
                                    class="v-select--xs w-full appearance-none rounded-full border-0 p-0 font-medium text-black-78 ring-1 ring-inset ring-gray placeholder:text-black-40 focus-within:ring-2 focus-within:ring-green"
                                    :options="phoneOptions"
                                    placeholder="Država"
                                    v-model="phoneOption"
                                    label="custom_label"
                                    @search:focus="onFocus"
                                    @search:blur="onBlur"
                                    ref="phone"
                                    id="phone"
                                    :name="'phone'"
                                >
                                    <template v-slot:no-options>
                                        Za ta iskalni niz ni zadetkov.
                                    </template>
                                </v-select>
                                <input
                                    type="hidden"
                                    name="userPhoneCountryCode"
                                    :value="
                                        phoneOption == null
                                            ? ''
                                            : phoneOption.value
                                    "
                                />
                            </div>
                            <div class="w-2/3">
                                <!--
                              <v-form-input
                                id="userPhoneCountryCode"
                                label="Država"
                                type="text"
                                class="mb-4 max-w-[100px]"
                                name="userPhoneCountryCode"
                              ></v-form-input>
                            -->
                                <template
                                    v-if="validationErrors.userPhoneCountryCode"
                                    ><!-- TODO: --></template
                                >
                                <v-form-input
                                    id="userPhone"
                                    label="Telefonska številka"
                                    type="tel"
                                    pattern="[0-9]"
                                    required="required"
                                    name="userPhone"
                                    v-model="userPhone"
                                ></v-form-input>
                                <template v-if="validationErrors.userPhone"
                                    ><!-- TODO: --></template
                                >
                            </div>
                        </figure>
                        <figure
                            class="flex w-full max-w-lg flex-col gap-3 lg:w-full"
                        >
                            <v-checkbox
                                class="flex-row-reverse justify-between text-body-medium"
                                name="registerWithNewsletterSubscribe"
                                label="Želim prejemati novice"
                            ></v-checkbox>
                            <v-checkbox
                                @checkchange="termsCheckedChanged"
                                class="flex-row-reverse justify-between text-body-medium"
                                name="registerWithTermsAgreed"
                                label='Strinjam se s spošnimi pogoji poslovanja in <a class="text-green underline" href="/izjava-o-varstvu-osebnih-podatkov">varstva osebnih podatkov</a>'
                            ></v-checkbox>
                        </figure>
                        <v-session-message
                            :session="session"
                        ></v-session-message>
                    </figure>
                </div>
            </form>
        </main>
        <footer
            class="sticky bottom-0 z-10 flex max-h-[102px] min-h-[102px] w-full justify-between border-t bg-white px-4 pt-4 lg:max-h-[90px] lg:min-h-[90px]"
        >
            <div class="flex w-full justify-center">
                <a
                    @click="submitForm('get-verification-code-form')"
                    @disabled="submitDisabled"
                    :class="[
                        'button min-w-[240px] h-[48px] md:h-[38px]',
                        submitDisabled ? 'button--gray' : 'button--form',
                    ]"
                >
                    <label>Nadaljujte</label>
                    <v-icon icon="arrow-right"></v-icon>
                </a>
            </div>
        </footer>
    </section>
</template>

<script>
export default {
    props: {
        registrationProcessData: {
            type: Object,
            required: true,
        },
        validationErrors: {
            type: Object,
            required: true,
            default: {},
        },
        phoneCodes: {
            type: Object,
            required: true,
        },
        session: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            phoneOption: {
                value: "SI",
                custom_label: "Slovenia",
            },
            hidePhoneLabel: false,
            userPhone: "",
            termsChecked: false,
        };
    },
    computed: {
        phoneOptions() {
            let parsedPhones = [];

            Object.values(this.phoneCodes).forEach((object) => {
                parsedPhones.push({
                    value: object.code,
                    custom_label: object.name,
                });
            });

            return parsedPhones;
        },
        submitDisabled() {
            return !this.termsChecked || this.userPhone == ""
        }
    },
    methods: {
        termsCheckedChanged(checked) {
            this.termsChecked = checked;
        },
        openLocation() {
            // Access the Vue Select instance using the ref
            const selectComponent = this.$refs.phone;

            // Check if the Vue Select instance exists and is defined
            if (selectComponent) {
                selectComponent.$refs.search.focus();
            }
        },
        onFocus() {
            this.hidePhoneLabel = true;
        },
        onBlur() {
            this.hidePhoneLabel = false;
        },
        submitForm(formId) {
            if(!this.termsChecked || this.userPhone == "")
                return;

            document.getElementById(formId).submit();
        },
    },
};
</script>
